<drawer-list-detail [listComponent]="listComponent" (drawer)="onReceiveDrawer($event)"></drawer-list-detail>

<ng-template #listComponent>
  <div class="w-full overflow-hidden rounded-lg px-7 pb-2 pt-6">
    <div class="text-center sm:text-start text-4xl font-extrabold leading-none tracking-tight pb-7 ">
      Gerenciamento de aplicações
  
      <div class="text-center sm:text-start text-lg font-semibold text-gray-500 pt-2">
        Aqui você pode visualizar, editar e adicionar aplicações
      </div>
    </div>
  
    <!-- Applications Total -->
    <div class="w-full flex flex-col items-center sm:flex-row sm:justify-between">
      <div class="flex w-auto">
        <span class="text-2xl font-semibold">Total de aplicações <span class="text-stone-500 font-medium">{{ totalCount() }}</span></span>
      </div>
  
      <!-- Actions -->
      <div class="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:justify-end sm:space-x-2 w-full sm:w-auto">
        <!-- Refresh -->
        <div class="w-full flex flex-row sm:w-auto hidden sm:flex">
          <!-- Refresh data button -->
          <div class="flex-auto">
            <button mat-icon-button (click)="onRefreshClick()" 
                    [@rotate]="loading().active && loading().type === loadingEnum.Refreshing ? 'loading' : 'default'" 
                    [disabled]="loading().active" 
                    matTooltip="Recarregar dados">
              <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
            </button>
          </div>
        </div>

        <!-- Search input -->
        <div class="flex-autow-full">
          <mat-form-field class="fuse-mat-dense fuse-mat-rounded mat-form-field-bg-light w-full min-w-50" subscriptSizing="dynamic">
            <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
            <input matInput [formControl]="searchInputControl" [autocomplete]="'off'" placeholder="pesquisar aplicações"/>
          </mat-form-field>
        </div>
  
        <!-- Add application button -->
        <button mat-flat-button color="primary" (click)="onAddApplicationClick($event)" [disabled]="loading().active">
          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          <span class="ml-2">Adicionar aplicação</span>
        </button>
      </div>
    </div>
  
    <div class="w-full overflow-x-auto h-full" style="overflow-y: auto;">
        <table class="w-full whitespace-no-wrap">
          <thead>
            <tr class="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase dark:border-gray-700 dark:text-gray-400" 
                style="position: sticky; top: 0; z-index: 10;">
              <th class="px-4 py-3 text-nowrap">Nome</th>
              <th class="px-4 py-3 text-nowrap">URI de Redirecionamento</th>
              <th class="px-4 py-3 text-nowrap">Modo de Autenticação</th>
              <th class="px-4 py-3 text-nowrap"></th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
            @for (app of applications(); track app.id)
            {
            <tr class="text-gray-700 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer">
              <td class="px-4 py-3 text-nowrap">
                <div class="flex flex-row items-center justify-start space-x-2">
                  <mat-icon class="icon-size-8" svgIcon="heroicons_outline:window"></mat-icon>
                  <div class="flex items-start">
                    <p class="font-semibold">{{app.name}}</p>
                  </div>
                </div>
              </td>
              <td class="px-4 py-3 text-nowrap">{{app.redirectUri}}</td>
              <td class="px-4 py-3 text-nowrap">{{app.authMode}}</td>
              <td class="px-4 py-3 text-nowrap">
                <div class="flex justify-end">
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon svgIcon="heroicons_outline:ellipsis-vertical"></mat-icon>
                  </button>
  
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onEditApplicationClick(app.id)" [disabled]="loading().active">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Editar</span>
                    </button>
                    <button mat-menu-item (click)="onDeleteApplicationClick(app.id)" [disabled]="loading().active">
                      <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                      <span>Deletar</span>
                    </button>
                  </mat-menu>
                </div>
              </td>
            </tr>
            }
            @empty {
            <tr>
              <td class="px-4 py-3 text-nowrap" colspan="5">
                <div class="flex flex-col items-center space-y-3 justify-center">
                  <mat-icon class="icon-size-14" svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                  <span class="text-lg">Nenhuma aplicação encontrada</span>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
    </div>

    <!-- Pagination -->
    <pagination-list
        [isLoading]="loading().active"
        [pageSize]="10"
        (paginationChanged)="loadApplications($event)">
    </pagination-list>
  </div>
</ng-template> 